var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-16"},[_c('div',{staticClass:"max-w-5xl mx-auto space-y-16"},[_vm._v("Landing")])])
}]

export { render, staticRenderFns }